// Safe environment variable access utility
export const getApiBaseUrl = () => {
  // Check if we're in a Vite environment
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    return import.meta.env.VITE_REACT_APP_PUBLIC_URL || 'https://itcsante-backend.onrender.com/';
  }
  
  // Fallback for other environments
  return 'https://itcsante-backend.onrender.com/';
};

export const getSupabaseUrl = () => {
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    return import.meta.env.VITE_REACT_APP_SUPABASE_URL || 'https://bendzdxeioiuzfoprvnz.supabase.co';
  }
  return 'https://bendzdxeioiuzfoprvnz.supabase.co';
};

export const getSupabaseKey = () => {
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    return import.meta.env.VITE_REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJlbmR6ZHhlaW9pdXpmb3Bydm56Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY1MDIyNTgsImV4cCI6MjA3MjA3ODI1OH0.rxu64UzVNBc__TwZYKv3dcpylkFtamBGsasiYOXu6UA';
  }
  return 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJlbmR6ZHhlaW9pdXpmb3Bydm56Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY1MDIyNTgsImV4cCI6MjA3MjA3ODI1OH0.rxu64UzVNBc__TwZYKv3dcpylkFtamBGsasiYOXu6UA';
};
